var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H20C22.4853 0.5 24.5 2.51472 24.5 5V20C24.5 22.4853 22.4853 24.5 20 24.5H5C2.51472 24.5 0.5 22.4853 0.5 20V5Z",
    stroke: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCheck);
export default __webpack_public_path__ + "static/media/unCheck.d472dfe5b6af3f8c4e27174c830f2d66.svg";
export { ForwardRef as ReactComponent };